import { offerChoicesSchema } from "@/zod-schemas/copilot/offer-choices-schema";

export const COPILOT_RUNTIME_URL = "/copilotkit";

// The runtime's agent name (copilot-runtime/server.ts).
export const COPILOT_AGENT_ID = "default";

export const COPILOT_LABELS = {
  modalHeaderTitle: "Zarlini Copilot",
  chatInputPlaceholder: "Ask anything",
  chatToggleOpenLabel: "Open Zarlini Copilot",
  chatToggleCloseLabel: "Close Zarlini Copilot",
  welcomeMessageText: "How can I help?",
};

export const COPILOT_ANSWER_FAILED = "Couldn't send your answer - please try again.";

// The offer_choices frontend tool (copilot-panel.tsx): the agent decides when to use it from this description.
export const OFFER_CHOICES_TOOL = {
  name: "offer_choices",
  parameters: offerChoicesSchema,
  description:
    "Ask the user to pick from 2-6 options you've found: which client, which date or slot, which services, or the " +
    "likely next step after an answer. Use it whenever you'd otherwise ask a question in text. Set multiple when " +
    "several can apply. Set allow_other only when you can act on whatever they type (a note, a preferred time, " +
    "a stylist preference) - never for picking from a fixed list such as services, stylists or slots.",
};

// Plain-language progress per agent step ([in progress, done]) - tool names are never shown.
// Keys are the backend tool names (backend/copilot/capabilities/); other names get no line.
export const COPILOT_STEP_LABELS = {
  search_clients: ["Looking up the client…", "Found the client"],
  get_client: ["Opening their visits…", "Checked their visits"],
  list_appointments: ["Checking the diary…", "Checked the diary"],
  get_availability: ["Checking who's free…", "Checked who's free"],
  create_appointment: ["Preparing the booking…", "Booking ready"],
  update_appointment: ["Preparing the change…", "Change ready"],
  list_services: ["Checking services and prices…", "Checked services and prices"],
  list_staff: ["Checking the team…", "Checked the team"],
  list_roster_changes: ["Checking the roster…", "Checked the roster"],
  list_products: ["Checking products…", "Checked products"],
  list_sales: ["Checking sales…", "Checked sales"],
  send_support_report: ["Preparing your report…", "Report ready"],
} as const satisfies Record<string, readonly [inProgress: string, done: string]>;

/** The backend tools the panel knows - a tool card for any other name is a type error, not a silent no-show. */
export type CopilotToolName = keyof typeof COPILOT_STEP_LABELS;
